export default "__VITE_ASSET__CQpHu0vo__"